import { setInitializedMap } from './setInitializedMap';
import { setRoutePoints } from './setRoutePoints';
import { resetRoutePoints } from './resetRoutePoints';
import { setShowStreetView } from './setShowStreetView';
import { updateSelectedPoint } from './updateSelectedPoint';
import { resetSelectedPoint } from './resetSelectedPoint';
import { updateFocusPoint } from './updateFocusPoint';
import { resetFocusPoint } from './resetFocusPoint';

export const mapOperations = {
  setInitializedMap,
  updateSelectedPoint,
  resetSelectedPoint,
  setRoutePoints,
  resetRoutePoints,
  setShowStreetView,
  updateFocusPoint,
  resetFocusPoint
};
